import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ColorPickerModule} from 'ngx-color-picker';
import {QuillModule} from 'ngx-quill';
import {NgSelectModule} from '@ng-select/ng-select';
import {routing} from '../../../app.routing';
import {FormValidationModule} from '~core/components/form-validation/form-validation.module';
import {FormFieldColorPickerComponent} from './form-field-color-picker/form-field-color-picker.component';
import {FormFieldDatepickerComponent} from './form-field-datepicker/form-field-datepicker.component';
import {FormFieldEmailCheckerComponent} from './form-field-email-checker/form-field-email-checker.component';
import {FormFieldEmailCheckerService} from './form-field-email-checker/form-field-email-checker.service';
import {FormFieldGenericTextComponent} from './form-field-generic-text/form-field-text-generic.component';
import {FormFieldIbanCheckerComponent} from './form-field-iban-checker/form-field-iban-checker.component';
import {FormFieldNumberComponent} from './form-field-number/form-field-number.component';
import {FormFieldPasswordComponent} from './form-field-password/form-field-password.component';
import {FormFieldRichTextComponent} from './form-field-rich-text/form-field-rich-text.component';
import {FormFieldSearchComponent} from './form-field-search/form-field-search.component';
import {FormFieldSelectComponent} from './form-field-select/form-field-select.component';
import {FormFieldStepperComponent} from './form-field-stepper/form-field-stepper.component';
import {FormFieldTextAreaComponent} from './form-field-textarea/form-field-textarea.component';
import {FormFieldToggleComponent} from './form-field-toggle/form-field-toggle.component';
import {FormOptionalFieldComponent} from './form-optional-field.component';
import {FormLabelTranslationService} from './translations/form-label-translations.service';
import {FormFieldCheckboxComponent} from './form-field-checkbox/form-field-checkbox.component';
import {FormFieldIconPickerComponent} from './form-field-icon-picker/form-field-icon-picker.component';
import {FormFieldImageUploadComponent} from '~shared/components/form-fields/form-field-image-upload/form-field-image-upload.component';
import {FormFieldMultiselectComponent} from '~shared/components/form-fields/form-field-multiselect/form-field-multiselect.component';

/**
 * Module for the Manage section
 */
@NgModule({
  declarations: [
    FormFieldPasswordComponent,
    FormOptionalFieldComponent,
    FormFieldEmailCheckerComponent,
    FormFieldIbanCheckerComponent,
    FormFieldGenericTextComponent,
    FormFieldTextAreaComponent,
    FormFieldDatepickerComponent,
    FormFieldSelectComponent,
    FormFieldSearchComponent,
    FormFieldToggleComponent,
    FormFieldColorPickerComponent,
    FormFieldRichTextComponent,
    FormFieldNumberComponent,
    FormFieldStepperComponent,
    FormFieldCheckboxComponent,
    FormFieldIconPickerComponent,
    FormFieldImageUploadComponent,
    FormFieldMultiselectComponent
  ],
  exports: [
    FormFieldPasswordComponent,
    FormOptionalFieldComponent,
    FormFieldEmailCheckerComponent,
    FormFieldIbanCheckerComponent,
    FormFieldGenericTextComponent,
    FormFieldTextAreaComponent,
    FormFieldDatepickerComponent,
    FormFieldSearchComponent,
    FormFieldSelectComponent,
    FormFieldToggleComponent,
    FormFieldColorPickerComponent,
    FormFieldRichTextComponent,
    FormFieldNumberComponent,
    FormFieldStepperComponent,
    FormFieldCheckboxComponent,
    FormFieldIconPickerComponent,
    FormFieldImageUploadComponent,
    FormFieldMultiselectComponent
  ],
  imports: [
    ReactiveFormsModule,
    routing,
    FormsModule,
    FormValidationModule,
    CommonModule,
    ColorPickerModule,
    QuillModule.forRoot(),
    NgSelectModule,
  ],
  providers: [
    FormFieldEmailCheckerService,
    FormLabelTranslationService
  ]
})
export class FormFieldsModule {
}
